// search.ts - 목록 검색용 문자열 정규화.

/**
 * 소문자 + 공백류(개행/탭 포함) 1칸 압축 + 양끝 trim.
 * 품명에 개행이 들어가도("LOCATOR\nINSERT") "locator insert" 로 검색되게 하려면
 * 검색어와 건초더미(haystack) 양쪽에 같은 정규화를 적용해야 한다.
 */
export const searchNorm = (s: string): string => s.toLowerCase().replace(/\s+/g, " ").trim();
